import BarChart from '@App/components/BarChart/BarChart';

import { RISK_DATA_KASUNGU } from '@App/pages/RiskDataPage/risk-data';
import { useTranslation } from '@utils/i18n/i18n.consumers';
import { GLOSSARY_ITEMS } from '@App/components/Navbar/GlossarySearch/glossary-search.constants';

import DefinitionComponent from '@App/components/DefinitionComponent/DefinitionComponent';
import RiskDataStories from '../RiskDataStories/RiskDataStories';

import { getMaxValue } from '../risk-data-content.utils';

import './risk-data-heat-wave.styl';

function RiskDataHeatWave({
  selectedScenario,
  selectedHorizon,
}) {
  const { t } = useTranslation();

  return (
    <div className="risk-data-heat-wave">
      <h3>{t('Introduction')}</h3>
      <p>
        {t('Temperature plays a fundamental role in human health, agricultural productivity and biodiversity. Heat is an important environmental hazard as heat stress is the leading cause of ')}
        <DefinitionComponent
          id={72}
          term="Weather"
          definition={GLOSSARY_ITEMS.find(item => item.id === 72)?.description}
          learnMoreUrl={GLOSSARY_ITEMS.find(item => item.id === 72)?.url}
          lowercase
        />
        {t('-related deaths. ')}
        <DefinitionComponent
          id={10}
          term="Climate change"
          definition={GLOSSARY_ITEMS.find(item => item.id === 10)?.description}
          learnMoreUrl={GLOSSARY_ITEMS.find(item => item.id === 10)?.url}
        />
        {t(' is increasing the frequency, intensity, and duration of heat waves.')}
      </p>
      <BarChart
        data={RISK_DATA_KASUNGU['heat-wave'][selectedScenario.id]}
        selectedItem={selectedHorizon.id}
        title={t('Number of days in heat wave conditions in the scenario of {{selectedScenario}}', { selectedScenario: t(selectedScenario.label).toLowerCase() })}
        xDataKey="horizon"
        yAxisLabel={t('Days/year')}
        yDataKey="value"
        yDomain={[0, getMaxValue(RISK_DATA_KASUNGU['heat-wave'])]}
      />
      <p>
        {t('A heat wave is a marked warming of the air over a large area, it usually lasts from a few days to a few weeks. A heat wave is defined when the maximum daily temperature overcomes a certain threshold temperature for at least 5 consecutive days. A way to measure how heat waves will become more frequent in the future is by counting the number of days in heat wave conditions.')}
      </p>
      <p>
        {t('In Kasungu the number of days in heat wave conditions is projected to increase significantly over the coming decades from about 22 in the current period to 61 in the long term for the medium emission scenario and even 84 for the high emission scenario. In other words, heat waves will become more frequent. As a result, the risk of heat waves is projected to increase to medium or high in future periods in Kasungu, depending on the emissions scenario.')}
      </p>
      <div className="how-does-this-affect-me__wrapper">
        <h3>
          {t('How does this affect me?')}
        </h3>
        <p>
          {t("Hot environments can overwhelm the body's heat-dissipating mechanisms. High temperatures can also amplify other hazards like ")}
          <DefinitionComponent
            id={23}
            term="Droughts"
            definition={GLOSSARY_ITEMS.find(item => item.id === 23)?.description}
            learnMoreUrl={GLOSSARY_ITEMS.find(item => item.id === 23)?.url}
            lowercase
          />
          {t(', ')}
          <DefinitionComponent
            id={73}
            term="Wildfire"
            definition={GLOSSARY_ITEMS.find(item => item.id === 73)?.description}
            learnMoreUrl={GLOSSARY_ITEMS.find(item => item.id === 73)?.url}
            lowercase
          />
          {t(', ')}
          <DefinitionComponent
            id={21}
            term="Cyclones"
            definition={GLOSSARY_ITEMS.find(item => item.id === 21)?.description}
            learnMoreUrl={GLOSSARY_ITEMS.find(item => item.id === 21)?.url}
            lowercase
          />
          {t(' and hazardous air quality. Heat affects vulnerable populations more severely including the elderly, pregnant people, outdoor workers, children and people with pre-existing illnesses.')}
        </p>
      </div>
      <h3>
        {t('How can we adapt?')}
      </h3>
      <p>
        {t('To tackle these risks it is important to organise early warning systems, raise community awareness, build the preparedness of the most vulnerable and incorporate education on heat waves.')}
      </p>
      <RiskDataStories hazardCategories={['heat-wave']} />
    </div>
  );
}

export default RiskDataHeatWave;